<template>
  <tr
    v-if="editProduct"
    class="h-20"
    :class="{
      'bg-red-300':
        editProduct.stockOnConfirmation !== null &&
        Number(editProduct.stockOnConfirmation) < Number(editProduct.quantity)
    }"
  >
    <td class="w-24">
      <img
        v-if="editProduct.image"
        class="w-20 h-20"
        :src="editProduct.image"
      />
    </td>
    <td>
      <button @click="viewProduct" class="flex flex-row">
        <img src="@/assets/icons/eye.svg" class="w-5 h-5 mr-2" />
        {{ `${editProduct.nkrCode} ` }}
      </button>
    </td>
    <td>
      {{ `${editProduct.line}` }}
      <span v-if="editProduct.warehouseCode">
        ({{ `${editProduct.warehouseCode}` }})
      </span>
    </td>
    <td>
      {{ `${editProduct.description}` }}
    </td>
    <td>
      {{ `${editProduct.brand}` }}
    </td>
    <td>
      <div
        class="flex flex-row justify-start items-center h-full justify-between px-2"
      >
        <template>
          {{ editProduct.price | currencyFormatted(true) }}
        </template>
        <BaseTooltip
          v-if="priceEdited"
          class="down"
          :text="`The price is different to current price. $${correctAmount}`"
        >
          <img src="@/assets/icons/warning.svg" class="ml-1 w-6 h-6" />
        </BaseTooltip>
      </div>
    </td>
    <td>
      <div class="flex flex-row items-center h-full justify-between px-2">
        <BaseTooltip
          class="left"
          v-if="
            editProduct.stockOnConfirmation !== null &&
              Number(editProduct.stockOnConfirmation) <
                Number(editProduct.quantity)
          "
          :text="
            `Incomplete Stock: ${currentStock} (${editProduct.canProvide}),
            Stock on confirmation: ${editProduct.stockOnConfirmation}`
          "
        >
          {{
            `${editProduct.kitItemsQuantityByKit ||
              editProduct.quantity} ${editProduct.type ||
              editProduct.pack ||
              "Items"}`
          }}
        </BaseTooltip>
        <BaseTooltip
          class="left"
          v-else-if="
            editProduct.stockOnConfirmation === null &&
              currentStock != null &&
              currentStock < editProduct.quantity
          "
          :text="
            `Incomplete Stock: ${currentStock} (${editProduct.canProvide})`
          "
        >
          {{
            `${editProduct.kitItemsQuantityByKit ||
              editProduct.quantity} ${editProduct.type ||
              editProduct.pack ||
              "Items"}`
          }}
          <img src="@/assets/icons/warning.svg" class="ml-1 w-6 h-6" />
        </BaseTooltip>
        <BaseTooltip
          class="left"
          v-else
          :text="
            editProduct.stockOnConfirmation
              ? `Stock on creation ${editProduct.stockOnConfirmation}`
              : `current stock ${currentStock}`
          "
        >
          {{
            `${editProduct.kitItemsQuantityByKit ||
              editProduct.quantity} ${editProduct.type ||
              editProduct.pack ||
              "Items"}`
          }}
        </BaseTooltip>
      </div>
    </td>
    <td>
      {{ totalPricePerItems | currencyFormatted(true) }}
      <!-- Descuento del cupón en esta línea (orders_v2_products.coupon_discount) -->
      <div
        v-if="Number(product.couponDiscount) > 0"
        class="text-xs font-semibold text-green-700 whitespace-nowrap"
        title="Coupon discount on this line"
      >
        -{{ product.couponDiscount | currencyFormatted(true) }}
      </div>
    </td>
    <td v-if="edit">
      <div class="flex flex-row justify-center items-center h-full px-2">
        <BaseModal
          id="edit-product-line"
          class="text-black"
          :value="editingLine"
          :allowClose="false"
        >
          <div>
            Editing product line
            <span class="text-red-700 font-bold">
              {{ editProduct.nkrCode }} - {{ editProduct.line }}
            </span>
            <div class="mt-10">
              <label for="price">Price</label>
              <input
                type="text"
                name="code"
                class="regular full bordered"
                v-model="editProduct.price"
              />
              <div
                v-if="currentOption"
                class="grid border border-gray-400 bg-gray-400 text-white mt-2 p-2"
                :class="priceColumns"
              >
                <div>line</div>
                <div class="text-center">Online</div>
                <div class="text-center">
                  Repair Shop
                </div>
                <div class="text-center">Wholesale</div>
                <div class="text-center" v-if="userCanSeePrecio4">Export</div>
                <div class="text-center" v-if="userCanSeePrecio5">GrupoNKR</div>
                <div class="text-center" v-if="userCanSeePrecio6">WH2</div>
                <div class="text-center">
                  stock
                </div>
              </div>
              <div
                v-if="currentOption"
                class="grid border border-gray-300 p-2"
                :class="priceColumns"
              >
                <div>{{ currentOption.line }}</div>
                <div
                  @click="editProduct.price = currentOption.online"
                  :class="{
                    'border-2 p-1 border-red-400':
                      transformedPriceLevel == 'online'
                  }"
                  class="text-center"
                >
                  {{ currency }}{{ currentOption.online }}
                </div>
                <div
                  :class="{
                    'border-2 p-1 border-red-400':
                      transformedPriceLevel == 'repairShop'
                  }"
                  @click="editProduct.price = currentOption.repairShop"
                  class="text-center"
                >
                  {{ currentOption.repairShop | currencyFormatted(true) }}
                </div>
                <div
                  @click="editProduct.price = currentOption.wholesale"
                  :class="{
                    'border-2 p-1 border-red-400':
                      transformedPriceLevel == 'wholesale'
                  }"
                  class="text-center"
                >
                  {{ currentOption.wholesale | currencyFormatted(true) }}
                </div>
                <div
                  v-if="userCanSeePrecio4"
                  @click="editProduct.price = currentOption.precio4"
                  :class="{
                    'border-2 p-1 border-red-400':
                      transformedPriceLevel == 'precio4'
                  }"
                  class="text-center"
                >
                  {{ currentOption.precio4 | currencyFormatted(true) }}
                </div>
                <div
                  v-if="userCanSeePrecio5"
                  @click="editProduct.price = currentOption.precio5"
                  :class="{
                    'border-2 p-1 border-red-400':
                      transformedPriceLevel == 'precio5'
                  }"
                  class="text-center"
                >
                  {{ currentOption.precio5 | currencyFormatted(true) }}
                </div>
                <div
                  v-if="userCanSeePrecio6"
                  @click="editProduct.price = currentOption.precio6"
                  :class="{
                    'border-2 p-1 border-red-400':
                      transformedPriceLevel == 'precio6'
                  }"
                  class="text-center"
                >
                  {{ currentOption.precio6 | currencyFormatted(true) }}
                </div>
                <div class="text-center">
                  {{
                    currentOption.stock ? currentOption.stock : "Not Available"
                  }}
                </div>
              </div>
            </div>
            <div class="mt-4">
              <label for="quantity">Quantity</label>
              <input
                type="number"
                name="code"
                class="regular full bordered"
                v-model="editProduct.quantity"
              />
              <p class="my-1 text-red-500">Current stock: {{ currentStock }}</p>
              <p
                v-if="currentStock < editProduct.quantity"
                class="mt-2 text-red-500"
              >
                {{ dropShipStatus }}
              </p>
            </div>
            <div class="flex flex-row mt-6">
              <button
                class="btn-dark-button"
                @click="cancelEditing()"
                v-if="editingLine"
              >
                Discard
              </button>
              <button
                class="btn-success-button ml-2"
                v-if="edited"
                @click="confirmEditing()"
              >
                Save
              </button>
            </div>
            <div
              class="mt-4 flex flex-col"
              v-if="otherOptions && otherOptions.length > 0"
            >
              <hr class="my-2" />
              <p>Other lines:</p>
              <dir
                class="grid border border-gray-500 bg-gray-500 text-white my-0 p-2 mt-2"
                :class="priceColumns"
              >
                <div>line</div>
                <div>online</div>
                <div>repair shop</div>
                <div>wholesale</div>
                <div v-if="userCanSeePrecio4">Export</div>
                <div v-if="userCanSeePrecio5">GrupoNKR</div>
                <div v-if="userCanSeePrecio6">WH2</div>
                <div class="text-center">stock</div>
              </dir>
              <div
                v-for="item in otherOptions"
                :key="item.productId"
                class="grid border border-gray-300 my-2 p-2"
                :class="priceColumns"
              >
                <div>{{ item.line }}</div>
                <div class="text-left">{{ item.online }}</div>
                <div class="text-center">
                  {{ item.repairShop | currencyFormatted(true) }}
                </div>
                <div class="text-center">
                  {{ item.wholesale | currencyFormatted(true) }}
                </div>
                <div class="text-center" v-if="userCanSeePrecio4">
                  {{ item.precio4 | currencyFormatted(true) }}
                </div>
                <div class="text-center" v-if="userCanSeePrecio5">
                  {{ item.precio5 | currencyFormatted(true) }}
                </div>
                <div class="text-center" v-if="userCanSeePrecio6">
                  {{ item.precio6 | currencyFormatted(true) }}
                </div>
                <div class="text-center">
                  {{ item.stock ? item.stock : "Not Available" }}
                </div>
              </div>
            </div>
          </div>
        </BaseModal>
        <button
          class="w-6 h-6 mr-4"
          @click="editingLine = true"
          v-if="!editingLine"
        >
          <img class="w-full h-full" src="@/assets/icons/edit.svg" alt="edit" />
        </button>
        <button class="w-6 h-6 mr-4" @click="removeItem()" v-if="!editingLine">
          <img
            class="w-full h-full"
            src="@/assets/icons/trash.svg"
            alt="delete"
          />
        </button>
      </div>
    </td>
  </tr>
</template>
<script>
let upFirst = word => word[0].toUpperCase() + word.toLowerCase().slice(1);

let camelize = text => {
  let words = text.split(/[-_]/g); // ok one simple regexp.
  return words[0].toLowerCase() + words.slice(1).map(upFirst);
};
export default {
  name: "ProductLine",
  components: {},
  props: {
    edit: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    priceLevel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      editingLine: false,
      editProduct: null
    };
  },
  computed: {
    getAdminSettings() {
      return this.$store.getters["general/getAdminSettings"];
    },
    currency() {
      const currencyObj = this.getAdminSettings.get("currency");
      return currencyObj?.value || "$";
    },
    userCanSeePrecio4() {
      return this.$store.getters["auth/userHasPermission"]("price_precio4");
    },
    userCanSeePrecio5() {
      return this.$store.getters["auth/userHasPermission"]("price_precio5");
    },
    userCanSeePrecio6() {
      return this.$store.getters["auth/userHasPermission"]("price_precio6");
    },
    priceColumns() {
      let columns = 5;
      if (this.userCanSeePrecio4) {
        columns++;
      }
      if (this.userCanSeePrecio5) {
        columns++;
      }
      if (this.userCanSeePrecio6) {
        columns++;
      }
      return `grid-cols-${columns}`;
    },
    dropShipStatus() {
      if (this.editProduct.canProvide == "stock_required") {
        return "No dropship available";
      }
      if (this.editProduct.canProvide == "drop_ship_enabled") {
        return "Drop ship available for this part";
      }

      return "";
    },
    transformedPriceLevel() {
      return camelize(this.priceLevel);
    },
    currentStock() {
      const currentProduct = this.product?.pricesAndStock?.find(product => {
        if (this.product.warehouseId) {
          return (
            product.productId == this.product.productId &&
            product.warehouseId == this.product.warehouseId
          );
        }
        return product.productId == this.product.productId;
      });
      if (currentProduct) {
        return Number(currentProduct.stock) ?? 0;
      }
      return 0;
    },
    priceEdited() {
      const currentProduct = this.product?.pricesAndStock?.find(product => {
        return (
          product.productId == this.product.productId &&
          product.warehouseId == this.product.warehouseId
        );
      });

      if (currentProduct) {
        return !(
          this.product.price == currentProduct[this.transformedPriceLevel]
        );
      }
      return false;
    },
    correctAmount() {
      if (this.priceEdited) {
        const currentProduct = this.product?.pricesAndStock?.find(product => {
          return (
            product.productId == this.product.productId &&
            product.warehouseId == this.product.warehouseId
          );
        });

        if (currentProduct) {
          return currentProduct[this.transformedPriceLevel];
        }
      }

      return "";
    },
    totalPricePerItems() {
      if (this.editProduct.kit && this.editProduct.kit !== "") {
        return "";
      }
      return (
        parseFloat(this.editProduct.quantity) *
        parseFloat(this.editProduct.price)
      );
    },
    edited() {
      return JSON.stringify(this.editProduct) !== JSON.stringify(this.product);
    },
    otherOptions() {
      return this.product?.pricesAndStock?.filter(item => {
        return item.productId !== this.product.productId;
      });
    },
    currentOption() {
      return this.product?.pricesAndStock?.find(item => {
        return item.productId == this.product.productId;
      });
    }
  },
  mounted() {
    this.editProduct = JSON.parse(JSON.stringify(this.product));
  },
  watch: {
    product: {
      deep: true,
      handler() {
        this.editProduct = JSON.parse(JSON.stringify(this.product));
      }
    }
  },
  methods: {
    cancelEditing() {
      this.editProduct = { ...this.product };
      this.editingLine = false;
    },
    removeItem() {
      this.$emit(
        this.product.productId ? "removeItemById" : "removeItem",
        this.product.productId || this.product.nkrCode
      );
    },
    confirmEditing() {
      if (this.editProduct.quantity == 0) {
        if (confirm("are you sure you want to delete this product?")) {
          this.$emit("removeItem", this.product.productId);
        }
      } else {
        this.$emit("confirmEditing", this.editProduct);
        this.editingLine = false;
      }
    },
    viewProduct() {
      this.$emit("viewProduct", this.product.nkrCode);
    }
  }
};
</script>
<style lang="postcss">
#edit-product-line {
  padding: 0px !important;
}
#edit-product-line .modal-content {
  width: 500px;
  height: auto;
  margin-top: auto;
  margin-bottom: auto;
}
#edit-product-line.active {
  display: flex !important;
}
</style>
